import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ServiceWorkerController from '#service-worker/controller';
import { deleteApiKeysOnSignOut } from '#action/user/api-key';
import { DrawerHeader, SideListContainer, StyledListItemText, StyledLogoutIcon } from './styles';
import MobileListItem from './mobile-list-item';
import DesktopListItem from './desktop-list-item';
import { isTrailLabel } from '#helper';
import { history } from '#configureStore';

const getSelectedItem = page => {
  const { pathname } = window.location;
  if (!page.route) return null;
  if (page.subMenuList) {
    return page.subMenuList.find(sm => pathname.includes(sm.route));
  }
  const trimmed = page.route.slice(1);
  if (pathname === `/add${trimmed}`) {
    return true;
  }

  if (!pathname.includes('-log')) {
    return pathname.includes(page.route);
  }

  return null;
};

const SideList = ({ socket, expanded, toggleDrawer, pagesList, drawerHeader, isMobile }) => {
  const dispatch = useDispatch();
  const [itemsState, setItemsState] = useState({});

  const listWidth = expanded ? 250 : 57;

  const getSubMenu = label => isTrailLabel(label) && itemsState[label];

  const handleSignOut = async () => {
    await Promise.all([
      ServiceWorkerController.unregisterSW(),
      dispatch(deleteApiKeysOnSignOut())
    ])
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });

    socket.emit('unauthorize');

    localStorage.removeItem('auth');
    document.cookie = 'auth=; expires=Fri, 31 Dec 1999 23:59:59 GMT;';

    history.replace('/login');
  };

  return (
    <SideListContainer style={{ width: listWidth }}>
      { drawerHeader &&
        <DrawerHeader>
          <IconButton onClick={toggleDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </DrawerHeader> }
      <Divider />
      <List>
        {pagesList.map(page => (
          isMobile ?
            <MobileListItem
              key={page.label}
              page={page}
              isTrail={isTrailLabel(page.label)}
              subMenu={getSubMenu(page.label)}
              toggleDrawer={toggleDrawer}
              setItemsState={setItemsState}
              selected={getSelectedItem(page)}
            /> :
            <DesktopListItem
              key={page.label}
              page={page}
              subMenu={getSubMenu(page.label)}
              setItemsState={setItemsState}
              expanded={expanded}
              selected={getSelectedItem(page)}
            />
        ))}
        <ListItemButton
          key="Sign out"
          onClick={handleSignOut}
        >
          <ListItemIcon>
            <StyledLogoutIcon />
          </ListItemIcon>
          <StyledListItemText primary="Sign out" />
        </ListItemButton>
      </List>
    </SideListContainer>);
};

export default SideList;
